import type { SVGProps } from 'react';

/**
 * Shipping Container icon — ISO intermodal container silhouette.
 * Accepts the same props as lucide icons (className, size, etc.)
 */
export default function ShippingContainerIcon({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number | string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* Container body */}
      <rect x="2" y="6" width="20" height="12" rx="1" />
      {/* Corrugated ridges */}
      <line x1="7" y1="6" x2="7" y2="18" />
      <line x1="12" y1="6" x2="12" y2="18" />
      <line x1="17" y1="6" x2="17" y2="18" />
      {/* Door handles / locking bars */}
      <line x1="19.5" y1="9" x2="19.5" y2="11" />
      <line x1="19.5" y1="13" x2="19.5" y2="15" />
      {/* Corner castings (top) */}
      <rect x="2" y="5" width="3" height="2" rx="0.5" />
      <rect x="19" y="5" width="3" height="2" rx="0.5" />
      {/* Corner castings (bottom) */}
      <rect x="2" y="17" width="3" height="2" rx="0.5" />
      <rect x="19" y="17" width="3" height="2" rx="0.5" />
    </svg>
  );
}
